// Casi clinico-estetici "Percorsi e Risultati".
// Per pubblicare foto/PDF: aggiungere i file in /public/casi e valorizzare before/after/pdf.
export const CASE_CATEGORIES = [
  "Viso e collo",
  "Occhi e perioculare",
  "Skin Quality",
  "Acne e cicatrici",
  "Macchie e rossori",
  "Corpo",
  "Capelli",
  "Laser dermatologico",
];

export const CASES = [
  {
    slug: "esiti-post-acneici-rossore-discromie",
    title: "Esiti post-acneici, rossore e discromie",
    protocol: "Protocollo combinato con laser frazionato Er:YAG e terapia domiciliare con acido azelaico 15%",
    category: "Viso e collo",
    tags: ["Laser frazionato Er:YAG", "Acido azelaico 15%", "Esiti post-acneici", "Discromie post-infiammatorie", "Rossore", "Texture cutanea"],
    before: null,
    after: null,
    pdf: "/casi/acne-scar-protocollo.pdf",
    pdfLabel: "Acne Scar — laser frazionato Er:YAG + acido azelaico 15%",
    compares: [
      {
        label: "Guancia destra",
        caption: "Riduzione delle lesioni infiammatorie e del rossore.",
        before: "/casi/esiti-acne-dx-prima.jpg",
        after: "/casi/esiti-acne-dx-dopo.jpg",
        beforeLabel: "Prima · 26.03",
        afterLabel: "Dopo · 10.09",
        ratio: "840 / 1120",
      },
      {
        label: "Guancia sinistra",
        caption: "Colorito più uniforme e texture più regolare.",
        before: "/casi/esiti-acne-sx-prima.jpg",
        after: "/casi/esiti-acne-sx-dopo.jpg",
        beforeLabel: "Prima · 26.03",
        afterLabel: "Dopo · 10.09",
        ratio: "840 / 1120",
      },
    ],
    observed: [
      "Riduzione della componente infiammatoria",
      "Miglioramento del rossore residuo",
      "Colorito più uniforme",
      "Texture cutanea più regolare",
    ],
    summary: {
      "Età paziente": "19 anni",
      "Problematica": "Esiti post-acneici: macchie post-infiammatorie, rossore residuo, texture irregolare, lesioni infiammatorie residue",
      "Protocollo utilizzato": "Laser frazionato Er:YAG + terapia domiciliare con acido azelaico 15%",
      "Numero sedute": "3 sedute laser · 26.03 — 10.05 — 20.06.2026",
      "Frequenza": "Una seduta ogni circa un mese e mezzo",
      "Inizio percorso": "Marzo 2026",
      "Ultimo controllo fotografico": "10 settembre 2026",
      "Area trattata": "Volto",
      "Obiettivo": "Ridurre l'infiammazione residua, migliorare discromie post-acneiche, uniformità del colorito e qualità cutanea",
      "Evoluzione attesa": "Percorso non concluso: il rimodellamento cutaneo prosegue nei mesi successivi",
    },
    note: "I risultati possono variare in base al tipo di pelle, alla profondità degli esiti post-acneici, alla risposta individuale e alla costanza nella terapia domiciliare.",
    body: [
      "Paziente di 19 anni, giunta alla valutazione con un quadro di esiti post-acneici del volto, caratterizzati da macchie post-infiammatorie, rossore residuo, irregolarità della texture cutanea e alcune lesioni infiammatorie ancora attive.",
      "Alla valutazione clinica il quadro non era riconducibile a un'unica problematica: oltre alla componente acneica residua, erano presenti segni lasciati dall'infiammazione precedente, con discromie superficiali, arrossamenti localizzati e una qualità cutanea disomogenea. Per questo è stato impostato un percorso progressivo con l'obiettivo di migliorare sia l'infiammazione residua sia la qualità della pelle, senza utilizzare trattamenti eccessivamente aggressivi per una cute giovane e sensibile.",
      "Il protocollo ha previsto un ciclo di 3 sedute di laser frazionato Er:YAG (26 marzo, 10 maggio e 20 giugno 2026), eseguite a distanza di circa un mese e mezzo l'una dall'altra, associate a una terapia domiciliare con acido azelaico 15%, introdotta gradualmente per favorire il controllo dell'infiammazione, la riduzione delle macchie post-infiammatorie e il mantenimento del risultato.",
      "Il percorso è iniziato nel mese di marzo e ha portato a un miglioramento progressivo nei mesi successivi. Si osserva una riduzione della componente infiammatoria, un miglioramento del rossore, una maggiore uniformità del colorito e una texture cutanea più regolare.",
      "L'obiettivo non era «cancellare» la pelle, ma accompagnarla in un processo di recupero graduale, rispettando i tempi biologici di guarigione e modulando i trattamenti in base alla risposta individuale. Il risultato è stato ottenuto attraverso un approccio integrato: trattamento laser in studio, terapia domiciliare mirata e monitoraggio nel tempo.",
      "Le immagini «dopo» risalgono al controllo del 10 settembre 2026: il percorso non è concluso. Trattandosi di un protocollo che stimola un progressivo rimodellamento cutaneo, il miglioramento tende a proseguire ancora nei mesi successivi, in base alla risposta individuale dei tessuti e alla costanza nella terapia domiciliare.",
    ],
  },

  {
    slug: "fotoinvecchiamento-lassita-qualita-cutanea",
    title: "Fotoinvecchiamento, lassità e qualità cutanea",
    protocol: "Protocollo combinato con fili di trazione e laser frazionato non ablativo",
    category: "Viso e collo",
    tags: ["Fili di trazione", "Laser frazionato non ablativo", "Fotoinvecchiamento", "Lassità", "Discromie", "Skin Quality"],
    before: null,
    after: null,
    pdf: "/casi/face-neck-tightening.pdf",
    pdfLabel: "Face & Neck Tightening — fili di trazione + laser frazionato non ablativo",
    compare: {
      before: "/casi/fotoinvecchiamento-prima.jpg",
      after: "/casi/fotoinvecchiamento-dopo.jpg",
      beforeLabel: "Prima · 03.06.2026",
      afterLabel: "Dopo · 28.08.2026",
      ratio: "780 / 790",
    },
    details: [
      {
        label: "Fronte",
        note: "Rughe orizzontali e glabella.",
        before: "/casi/fotoinvecchiamento-fronte-prima.jpg",
        after: "/casi/fotoinvecchiamento-fronte-dopo.jpg",
        ratio: "893 / 285",
        annotations: [
          { x: 50, y: 30, label: "Rughe orizzontali frontali", score: { before: "2,7", after: "2,0" } },
          { x: 50, y: 60, label: "Ruga glabellare" },
        ],
      },
      {
        label: "Occhi e sguardo",
        note: "Zona perioculare: rughe e affaticamento dello sguardo.",
        before: "/casi/fotoinvecchiamento-occhi-prima.jpg",
        after: "/casi/fotoinvecchiamento-occhi-dopo.jpg",
        ratio: "893 / 380",
        annotations: [
          { x: 17, y: 50, label: "Zampe di gallina (dx paziente)" },
          { x: 83, y: 48, label: "Zampe di gallina (sx paziente)", align: "right" },
          { x: 32, y: 70, label: "Rughe sottopalpebrali" },
        ],
      },
      {
        label: "Guance e contorno bocca",
        note: "Solchi naso-labiali e rughe periorali.",
        before: "/casi/fotoinvecchiamento-guance-prima.jpg",
        after: "/casi/fotoinvecchiamento-guance-dopo.jpg",
        ratio: "893 / 380",
        annotations: [
          { x: 34, y: 40, label: "Solco naso-genieno", score: { before: "3,2", after: "2,5" } },
          { x: 66, y: 40, label: "Solco naso-genieno", align: "right", score: { before: "3,5", after: "2,5" } },
          { x: 50, y: 52, label: "Rughe periorali (codice a barre)" },
        ],
      },
      {
        label: "Collo",
        note: "Rughe orizzontali e texture cutanea del collo.",
        before: "/casi/fotoinvecchiamento-collo-prima.jpg",
        after: "/casi/fotoinvecchiamento-collo-dopo.jpg",
        ratio: "646 / 238",
        annotations: [
          { x: 48, y: 66, label: "Rughe orizzontali (collane di Venere)" },
        ],
      },
    ],
    gallery: [
      {
        src: "/casi/fotoinvecchiamento-confronto.jpg",
        label: "Confronto fotografico",
        caption: "Acquisizione AURA · Prima 03.06.2026 — Dopo 28.08.2026.",
      },
      {
        src: "/casi/fotoinvecchiamento-analisi-rughe.jpg",
        label: "Analisi delle rughe (AURA)",
        caption: "Mappatura oggettiva delle rughe: punteggio complessivo da 3,1 a 2,4 (−0,7).",
        scores: {
          title: "Punteggio rughe",
          overall: { before: "3,1", after: "2,4", delta: "−0,7" },
          zones: [
            { name: "Fronte", before: "2,7", after: "2,0" },
            { name: "Guancia sx", before: "3,5", after: "2,5" },
            { name: "Guancia dx", before: "3,2", after: "2,5" },
          ],
        },
      },
      {
        src: "/casi/fotoinvecchiamento-analisi-rilievo.jpg",
        label: "Analisi del rilievo cutaneo (AURA)",
        caption: "Mappatura del rilievo e della texture: punteggio complessivo da 3,7 a 2,8 (−0,9).",
        scores: {
          title: "Punteggio rilievo",
          overall: { before: "3,7", after: "2,8", delta: "−0,9" },
          zones: [
            { name: "Fronte", before: "3,8", after: "2,7" },
            { name: "Guancia sx", before: "3,7", after: "2,5" },
            { name: "Guancia dx", before: "3,5", after: "2,9" },
          ],
        },
      },
    ],
    summary: {
      "Età paziente": "62 anni",
      "Problematica": "Fotoinvecchiamento moderato-severo, rughe statiche diffuse, discromie, lassità del terzo medio",
      "Protocollo utilizzato": "Fili di trazione + laser frazionato non ablativo",
      "Area trattata": "Volto",
      "Obiettivo": "Riposizionamento tissutale, miglioramento di texture, discromie e qualità cutanea",
      "Rivalutazione fotografica": "Circa 3 mesi",
      "Massimo effetto atteso": "Circa 6 mesi",
    },
    note: "I risultati possono variare in base a qualità dei tessuti, grado di fotoinvecchiamento, lassità cutanea e risposta individuale.",
    body: [
      "Paziente di 62 anni, giunta alla valutazione con un quadro di fotoinvecchiamento moderato-severo, caratterizzato da rughe statiche diffuse, discromie cutanee evidenti, irregolarità della texture e iniziale cedimento del terzo medio del volto.",
      "Alla valutazione clinica il problema non era riconducibile a un singolo inestetismo, ma a più componenti sovrapposte: perdita di qualità cutanea, fotodanno, alterazioni cromatiche superficiali e riduzione del supporto dei tessuti del volto. Per questo è stato impostato un protocollo combinato, con l'obiettivo di lavorare sia sulla struttura sia sulla superficie cutanea.",
      "Il percorso ha previsto l'utilizzo di fili di trazione per favorire un riposizionamento selettivo dei tessuti e migliorare il sostegno del terzo medio, associati a laser frazionato non ablativo per stimolare il rimodellamento dermico e migliorare texture, discromie superficiali e rossore diffuso. L'obiettivo non era modificare i volumi del volto, ma ottenere un miglioramento progressivo e naturale di compattezza, qualità della pelle e armonia complessiva.",
      "A distanza di circa tre mesi si osserva un miglioramento della qualità cutanea, con riduzione dell'aspetto segnato della pelle, maggiore uniformità del colorito e un aspetto complessivamente più disteso del volto.",
      "Trattandosi di un protocollo che stimola un progressivo rimodellamento dei tessuti, il risultato non è immediato e tende a migliorare nei mesi successivi: il massimo dell'effetto è atteso generalmente intorno ai 6 mesi, in base alla risposta individuale dei tessuti. Il risultato è stato ottenuto attraverso un approccio integrato e personalizzato, costruito sulla valutazione della paziente e non sull'utilizzo di un singolo trattamento standard.",
    ],
  },

  {
    slug: "body-reset-adiposita-diffusa-lassita",
    title: "Body Reset — adiposità diffusa e lassità",
    protocol: "6 sedute di radiofrequenza + 6 di PowerShape",
    category: "Corpo",
    tags: ["Radiofrequenza", "PowerShape", "Addome e fianchi"],
    summary: {
      "Età": "62 anni",
      "Problematica": "Adiposità diffusa del distretto addomino-femorale con lassità cutanea",
      "Protocollo": "Body Reset · 6 radiofrequenza + 6 PowerShape",
      "Area": "Addome, fianchi, radice delle cosce",
      "Obiettivo": "Compattezza cutanea e rimodellamento del profilo",
    },
    observed: [
      "Punto vita più definito",
      "Fianchi meno prominenti",
      "Profilo addomino-femorale più uniforme e compatto",
    ],
    measures: [
      { label: "Punto vita", before: 96, after: 89 },
      { label: "Fianchi", before: 114, after: 108 },
    ],
    gallery: [
      {
        src: "/casi/body-reset-adiposita-diffusa-lassita.jpg",
        label: "Prima e dopo",
        caption: "Profilo addomino-femorale prima e al termine del ciclo Body Reset.",
      },
    ],
    body: [
      "Quadro iniziale caratterizzato da adiposità diffusa del distretto addomino-femorale, associata a lassità cutanea e ridotta compattezza dei tessuti, più evidente a livello di addome, fianchi e radice delle cosce.",
      "È stato eseguito un protocollo Body Reset composto da 6 sedute di radiofrequenza e 6 sedute di PowerShape. La radiofrequenza è stata utilizzata per lavorare sulla compattezza e sulla qualità cutanea; PowerShape per il rimodellamento del pannicolo sottocutaneo e la qualità del tessuto.",
      "Al termine del ciclo si osserva un miglioramento della definizione del punto vita, una riduzione della prominenza dei fianchi e una maggiore uniformità e compattezza del profilo addomino-femorale.",
      "Percorso personalizzato su adiposità sottocutanea e lassità cutanea.",
    ],
    pdf: "/casi/body-reset-addome.pdf",
    pdfLabel: "Body Reset — Addome (radiofrequenza + PowerShape)",
    note: "I risultati dei trattamenti corpo dipendono dalle caratteristiche dei tessuti, dallo stile di vita e dalla risposta individuale, e possono variare da persona a persona. Le immagini si riferiscono a un singolo caso e non costituiscono una promessa di risultato.",
  },

  {
    slug: "body-reset-culotte-de-cheval",
    title: "Cellulite & Drainage — Culotte de Cheval",
    protocol: "6 sedute di ZWave / onde d'urto + 6 di mesoterapia drenante",
    category: "Corpo",
    tags: ["Cellulite & Drainage", "ZWave / onde d'urto", "Mesoterapia drenante"],
    summary: {
      "Età": "26 anni",
      "Problematica": "Adiposità localizzata trocanterica bilaterale (\u201cculotte de cheval\u201d) e irregolarità del tessuto",
      "Protocollo": "Cellulite & Drainage · 6 ZWave/onde d'urto + 6 mesoterapia drenante",
      "Area": "Regione gluteo-femorale / trocanterica",
      "Obiettivo": "Continuità del profilo gluteo-coscia e uniformità del tessuto",
    },
    observed: [
      "Prominenza trocanterica ridotta",
      "Profilo gluteo-coscia più continuo",
      "Tessuto più uniforme",
    ],
    gallery: [
      {
        src: "/casi/body-reset-culotte-de-cheval.jpg",
        label: "Prima e dopo",
        caption: "Regione gluteo-femorale prima e al termine del ciclo Cellulite & Drainage.",
      },
    ],
    body: [
      "Quadro iniziale caratterizzato da adiposità localizzata in sede trocanterica bilaterale (\u201cculotte de cheval\u201d), associata a irregolarità del tessuto della regione gluteo-femorale.",
      "È stato eseguito un protocollo Cellulite & Drainage composto da 6 sedute di ZWave / onde d'urto e 6 sedute di mesoterapia drenante. Le onde d'urto sono state utilizzate per lavorare sulla consistenza e sull'irregolarità del tessuto; la mesoterapia come supporto sulla componente ritentiva e sulla qualità del pannicolo.",
      "Al termine del ciclo si osserva una riduzione della prominenza trocanterica, con maggiore continuità del profilo tra gluteo e coscia e miglioramento dell'uniformità del tessuto.",
      "Percorso personalizzato su adiposità localizzata e componente ritentiva.",
    ],
    pdf: "/casi/body-reset-culotte.pdf",
    pdfLabel: "Cellulite & Drainage — Culotte de cheval (ZWave + mesoterapia drenante)",
    note: "I risultati dei trattamenti corpo dipendono dalle caratteristiche dei tessuti, dallo stile di vita e dalla risposta individuale, e possono variare da persona a persona. Le immagini si riferiscono a un singolo caso e non costituiscono una promessa di risultato.",
  },
];

export const CASES_BY_SLUG = Object.fromEntries(CASES.map((c) => [c.slug, c]));
